// Country code → English name, mirrored from airbnb-elevate-fe
// (`coAlarm:countries` translations). Keys are lowercase ISO 3166-1 alpha-2.
export const COUNTRY_NAMES_BY_CODE: Record<string, string> = {
    ad: 'Andorra',
    ae: 'United Arab Emirates',
    af: 'Afghanistan',
    ag: 'Antigua and Barbuda',
    al: 'Albania',
    am: 'Armenia',
    ao: 'Angola',
    ar: 'Argentina',
    at: 'Austria',
    au: 'Australia',
    az: 'Azerbaijan',
    ba: 'Bosnia and Herzegovina',
    bb: 'Barbados',
    bd: 'Bangladesh',
    be: 'Belgium',
    bf: 'Burkina Faso',
    bg: 'Bulgaria',
    bh: 'Bahrain',
    bi: 'Burundi',
    bj: 'Benin',
    bn: 'Brunei Darussalam',
    bo: 'Bolivia (Plurinational State of)',
    br: 'Brazil',
    bs: 'Bahamas',
    bt: 'Bhutan',
    bw: 'Botswana',
    by: 'Belarus',
    bz: 'Belize',
    ca: 'Canada',
    cd: 'Congo, Democratic Republic of the',
    cf: 'Central African Republic',
    cg: 'Congo',
    ch: 'Switzerland',
    ci: "Côte d'Ivoire",
    cl: 'Chile',
    cm: 'Cameroon',
    cn: 'China',
    co: 'Colombia',
    cr: 'Costa Rica',
    cu: 'Cuba',
    cv: 'Cabo Verde',
    cy: 'Cyprus',
    cz: 'Czechia',
    de: 'Germany',
    dj: 'Djibouti',
    dk: 'Denmark',
    dm: 'Dominica',
    do: 'Dominican Republic',
    dz: 'Algeria',
    ec: 'Ecuador',
    ee: 'Estonia',
    eg: 'Egypt',
    er: 'Eritrea',
    es: 'Spain',
    et: 'Ethiopia',
    fi: 'Finland',
    fj: 'Fiji',
    fm: 'Micronesia (Federated States of)',
    fr: 'France',
    ga: 'Gabon',
    gb: 'United Kingdom of Great Britain and Northern Ireland',
    gd: 'Grenada',
    ge: 'Georgia',
    gh: 'Ghana',
    gm: 'Gambia',
    gn: 'Guinea',
    gq: 'Equatorial Guinea',
    gr: 'Greece',
    gt: 'Guatemala',
    gw: 'Guinea-Bissau',
    gy: 'Guyana',
    hn: 'Honduras',
    hr: 'Croatia',
    ht: 'Haiti',
    hu: 'Hungary',
    id: 'Indonesia',
    ie: 'Ireland',
    il: 'Israel',
    in: 'India',
    iq: 'Iraq',
    ir: 'Iran (Islamic Republic of)',
    is: 'Iceland',
    it: 'Italy',
    jm: 'Jamaica',
    jo: 'Jordan',
    jp: 'Japan',
    ke: 'Kenya',
    kg: 'Kyrgyzstan',
    kh: 'Cambodia',
    ki: 'Kiribati',
    km: 'Comoros',
    kn: 'Saint Kitts and Nevis',
    kp: "Korea (Democratic People's Republic of)",
    kr: 'Korea, Republic of',
    kw: 'Kuwait',
    kz: 'Kazakhstan',
    la: "Lao People's Democratic Republic",
    lb: 'Lebanon',
    lc: 'Saint Lucia',
    li: 'Liechtenstein',
    lk: 'Sri Lanka',
    lr: 'Liberia',
    ls: 'Lesotho',
    lt: 'Lithuania',
    lu: 'Luxembourg',
    lv: 'Latvia',
    ly: 'Libya',
    ma: 'Morocco',
    mc: 'Monaco',
    md: 'Moldova, Republic of',
    me: 'Montenegro',
    mg: 'Madagascar',
    mh: 'Marshall Islands',
    mk: 'North Macedonia',
    ml: 'Mali',
    mm: 'Myanmar',
    mn: 'Mongolia',
    mr: 'Mauritania',
    mt: 'Malta',
    mu: 'Mauritius',
    mv: 'Maldives',
    mw: 'Malawi',
    mx: 'Mexico',
    my: 'Malaysia',
    mz: 'Mozambique',
    na: 'Namibia',
    ne: 'Niger',
    ng: 'Nigeria',
    ni: 'Nicaragua',
    nl: 'Netherlands',
    no: 'Norway',
    np: 'Nepal',
    nr: 'Nauru',
    nz: 'New Zealand',
    om: 'Oman',
    pa: 'Panama',
    pe: 'Peru',
    pg: 'Papua New Guinea',
    ph: 'Philippines',
    pk: 'Pakistan',
    pl: 'Poland',
    pt: 'Portugal',
    pw: 'Palau',
    py: 'Paraguay',
    qa: 'Qatar',
    ro: 'Romania',
    rs: 'Serbia',
    ru: 'Russian Federation',
    rw: 'Rwanda',
    sa: 'Saudi Arabia',
    sb: 'Solomon Islands',
    sc: 'Seychelles',
    sd: 'Sudan',
    se: 'Sweden',
    sg: 'Singapore',
    si: 'Slovenia',
    sk: 'Slovakia',
    sl: 'Sierra Leone',
    sm: 'San Marino',
    sn: 'Senegal',
    so: 'Somalia',
    sr: 'Suriname',
    ss: 'South Sudan',
    st: 'Sao Tome and Principe',
    sv: 'El Salvador',
    sy: 'Syrian Arab Republic',
    sz: 'Eswatini',
    td: 'Chad',
    tg: 'Togo',
    th: 'Thailand',
    tj: 'Tajikistan',
    tl: 'Timor-Leste',
    tm: 'Turkmenistan',
    tn: 'Tunisia',
    to: 'Tonga',
    tr: 'Türkiye',
    tt: 'Trinidad and Tobago',
    tv: 'Tuvalu',
    tz: 'Tanzania, United Republic of',
    ua: 'Ukraine',
    ug: 'Uganda',
    us: 'United States of America',
    uy: 'Uruguay',
    uz: 'Uzbekistan',
    vc: 'Saint Vincent and the Grenadines',
    ve: 'Venezuela (Bolivarian Republic of)',
    vn: 'Viet Nam',
    vu: 'Vanuatu',
    ws: 'Samoa',
    ye: 'Yemen',
    za: 'South Africa',
    zm: 'Zambia',
    zw: 'Zimbabwe'
}

/** Maps an ISO alpha-2 country code (any case) to its English name; '' if unknown. */
export const countryNameFromCode = (code?: string | null): string =>
    (code && COUNTRY_NAMES_BY_CODE[code.toLowerCase()]) || ''
